import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SmartLabelService } from '../smart-label/smart-label.service';
interface footerCtrlInterface {
  sticky?: boolean;
  isContentFooter?: boolean;
  class?: string;
  content: Array<{
    languageCode: string;
    value:string;
  }>
}
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnChanges {

  @Input() config: any;

  public content: string;

  constructor(
    private smartLabelService: SmartLabelService) { }

  /**
   * @description - Footer Section in Smartlabel
   * @author - Abhishek
   * @task - QLIKTAG-2896
   */
  ngOnInit() {
    //console.log(this.config);
    // this.content = this.config.content;
  }
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes.config) {
      if (this.config) {
        this.content = this.config.content;
      }
    }
  }

}
